/***
 * 地点
 */

import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { API_GET_PUBLIC_SHOP_LIST_AUTH } from '@api';
import { Debounce, Bind } from 'lodash-decorators';
class Location extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      AddCodeData: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.getAddCodeFunc();
  }

  // 获取地点
  getAddCodeFunc = value => {
    this.setState({ loading: true, AddCodeData: [] });
    getData({
      api: API_GET_PUBLIC_SHOP_LIST_AUTH,
      searchParams: {
        keyword: value,
      },
    })
      .then(res => {
        const { data } = res;
        this.setState({
          AddCodeData: data,
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  @Bind()
  @Debounce(1000)
  handleSearch(value) {
    if (!value) return false;
    this.getAddCodeFunc(value);
  }

  render() {
    const { AddCodeData, loading } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        mode={!isSingleSelect && 'tags'}
        tokenSeparators={[' ']}
        optionFilterProp="children"
        allowClear
        filterOption={false}
        notFoundContent={loading ? <Spin size="small" /> : '查询结果为空'}
        onSearch={this.handleSearch}
        showSearch
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {AddCodeData.map(item => (
          <Select.Option
            title={`${item.code}-${item.name}`}
            key={item.code}
            item={item}
            value={
              renderValue ? renderValue(item) : `${item.code}-${item.name}`
            }>{`${item.code}-${item.name}`}</Select.Option>
        ))}
      </Select>
    );
  }
}

export default Location;
